import { SHOW_KEYBOARD, GENERATE_DEVICE_ID } from '../constants/appConstants';

export const showKeyboard = (payload) => ({ type: SHOW_KEYBOARD, payload });
export const generateDeviceId = (payload) => ({ type: GENERATE_DEVICE_ID, payload });
